import { doc, getDoc, setDoc } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { db } from './firebase';

const FEATURES_DOC = doc(db, 'config', 'features');

// ─── Feature flag ─────────────────────────────────────────────────────────────

export const getAccessFeatureEnabled = async () => {
  try {
    const snap = await getDoc(FEATURES_DOC);
    return snap.exists() ? (snap.data().accessCodesEnabled ?? false) : false;
  } catch {
    return false;
  }
};

export const setAccessFeatureEnabled = async (enabled) => {
  await setDoc(FEATURES_DOC, { accessCodesEnabled: enabled }, { merge: true });
};

// ─── PIN management ───────────────────────────────────────────────────────────

/**
 * Returns the user's existing access PIN or generates a unique new one.
 * Calls a Cloud Function that uses admin SDK to bypass Firestore security rules
 * (regular users can't query other users' PINs for uniqueness checking).
 */
export const getOrCreateAccessPin = async (userId) => {
  const fns = getFunctions(undefined, 'australia-southeast1');
  const fn = httpsCallable(fns, 'getOrCreateAccessPin');
  const res = await fn(userId ? { userId } : {});
  return res.data?.pin;
};

/**
 * Generates a unique 4-digit PIN for a guest/team-member booking.
 * Uses a Cloud Function to bypass Firestore rules that block cross-user queries.
 */
export const generateUniquePin = async () => {
  const fns = getFunctions(undefined, 'australia-southeast1');
  const fn = httpsCallable(fns, 'generateUniquePin');
  const res = await fn({});
  return res.data?.pin;
};
